import { createSlice } from '@reduxjs/toolkit';
import { createDataSources, dataSourceHistoryByPage, deleteDataSources, getDataSourceById, getDataSourcesList, updateDataSourceById, uploadDataSourceFile } from '../thunks/dataSourcesThunk';
import { toast } from 'react-toastify';


const dataSourcesSlice = createSlice({
  name: 'dataSources',
  initialState: {
    error: null,
    isLoading: true,
    dataSourcesList: [],
    dataSource:{},
    isEditTrigger: false,
    isNewTrigger: false,
    selected: [],
    selectAll: false,
    isChanged: 0,
    partner_connection_id: 0,
    dataSourceHistory: {
        historyData: [],
        pageSize: 20,
        totalRecordsFetch: 0,
        totalPages: 0,
    },
    
  },
  reducers: {
    handleEditOpen(state, action){
        return {...state, isEditTrigger: true}
    },
    handleEditClose(state, action){
        return {...state, isEditTrigger: false, dataSource:{}}
    },
    handleNew(state, action){
        return {...state, isNewTrigger: !action.payload}
    },
    handleSelected(state, action) {
        let updatedSelected = [];
    
        if (action.payload.type === 'SET_SELECTED_ROWS') {
            const selectedId = action.payload.selectedId;
            const isSelected = state.selected.includes(selectedId);
    
            if (isSelected) {
                updatedSelected = state.selected.filter(id => id !== selectedId);
            } else {
                updatedSelected = [...state.selected, selectedId];
            }
        }
    
        if (action.payload.type === 'SELECT_ALL') {
            updatedSelected = state.selectAll ? [] : (state.dataSourcesList || []).map((row) => row.id);
        }
    
        const selectAll = state.dataSourcesList.length === updatedSelected.length;
    
        return {
            ...state,
            selected: updatedSelected,
            selectAll,
        };
    },
    setSelectAllFalse(state, action){
        return {
            ...state,
            selectAll: false,
          };
    }
    
  },
  extraReducers: (builder) => {
    builder
        .addCase(getDataSourcesList.fulfilled, (state,action) => {
            state.dataSourcesList = action.payload?.sources || [];
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getDataSourcesList.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getDataSourcesList.rejected, (state, action) => {
            state.isLoading = false;
            state.dataSourcesList = [];
            state.error = action.payload;
        })
        .addCase(getDataSourceById.fulfilled, (state,action) => {
            state.dataSource = action.payload?.source;
            state.partner_connection_id = action.payload?.source?.partner_connection_id;
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getDataSourceById.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getDataSourceById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload?.error)
        })
        .addCase(createDataSources.fulfilled, (state,action) => {
            if(action.payload.status_code === 200){
                state.dataSource = action.payload?.source;
                state.isChanged+= 1;
                state.isEditTrigger = true;
                toast.success(action.payload?.success)
            }
            else{
                state.dataSource = {};
                toast.error(action.payload)  
            }
            state.error = null;
            state.isLoading = false;
        })
        .addCase(createDataSources.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(createDataSources.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(updateDataSourceById.fulfilled, (state,action) => {
            if(action.payload.status_code === 200){
                state.isEditTrigger = true;
                toast.success(action.payload?.success)
                state.isChanged+= 1;
                state.partner_connection_id = action.payload?.source?.partner_connection_id;
            }
            else{
                toast.error(action.payload)  
            }
            state.error = null;
            state.isLoading = false;
        })
        .addCase(updateDataSourceById.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(updateDataSourceById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(deleteDataSources.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload?.status_code){
                toast.success(action.payload?.success)
                state.isChanged+= 1;
            }
            else{
                toast.error(action.payload?.error);
            }
        })
        .addCase(deleteDataSources.pending, (state, action) => {
            state.isLoading= true;
            state.error = null;
        })
        .addCase(deleteDataSources.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload);
        })
        .addCase(dataSourceHistoryByPage.fulfilled, (state,action) => {
            state.dataSourceHistory = action.payload?.logs;
            state.dataSourceHistory.pageSize = action.payload?.logs?.per_page;
            state.dataSourceHistory.totalPages = action.payload?.logs?.last_page;
            state.dataSourceHistory.historyData = action.payload?.logs?.data;
            state.error = null;
            state.isLoading = false;
        })
        .addCase(dataSourceHistoryByPage.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(dataSourceHistoryByPage.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(uploadDataSourceFile.fulfilled, (state,action) => {
            if(action.payload.status_code === 200){
                state.isEditTrigger = true;
                toast.success(action.payload?.success)
                state.isChanged+= 1;
            }
            state.error = null;
            state.isLoading = false;
        })
        .addCase(uploadDataSourceFile.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(uploadDataSourceFile.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
       
}

});

export const actions = dataSourcesSlice.actions;
export default dataSourcesSlice.reducer;
